import KonvaService from '.';
import { Shape as KonvaShape } from 'konva/lib/Shape';
import { KonvaUtils } from './konva.utils';
import { Node } from 'konva/lib/Node';
import { Group } from 'konva/lib/Group';

export class KonvaGroup {
  private konvaService: KonvaService;
  constructor(konvaService: KonvaService) {
    this.konvaService = konvaService;
    this.bindEvent();
  }

  /**
   * 绑定双击group事件
   */
  private bindEvent() {
    const stage = this.konvaService.stage;

    // 鼠标双击
    stage.on('dblclick', (e) => {
      const target = e.target as KonvaShape;
      const group = KonvaUtils.getInteractableNode(target) as Node;
      if (!KonvaUtils.isNodeEnabled(group)) {
        return;
      }

      const data = group.getAttr('data');
      if (!data?.group || data.group?.getAttr('data')?.explode) {
        return;
      }
      KonvaUtils.toggleGroupExplode(data.group, true);

      // 再次获取getInteractableNode
      const target2 = KonvaUtils.getInteractableNode(target);
      this.konvaService.selection?.selectNodes([target2]);
    });

    // 鼠标按下时，解除explode状态
    stage.on('mousedown', (e) => {
      const target = e.target as KonvaShape;
      const target2 = KonvaUtils.getInteractableNode(target);
      // 将所有未激活的group取消explode
      const groups = stage.find('#group') as Group[];

      groups
        // 不能包括当前的
        .filter((group) => {
          if (group.children?.includes(target)) return false;
          if (group.children?.includes(target2?.getAttr('data')?.group))
            return false;
          return true;
        })
        .forEach((group) => {
          // 如果是其他group则处理数据
          KonvaUtils.toggleGroupExplode(group, false);
        });
    });
  }
}
